module.exports = __webpack_public_path__ + "img/Intersection 47.57f0649a.png";